import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {Link} from 'react-router-dom';
import ApplicationPage from '../../shared/pages/ApplicationPage';
import StoreOrderForm from '../components/StoreOrderForm';
import {getInitialValuesFromTemplate} from '../utils/formUtils';
import {Back} from '../../shared/icons';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(3)
  },
  back: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3)
  },
  successMessage: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.contrastText,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(2),
    textAlign: 'center'
  }
}));

const StoreOrderPage = ({
  template,
  ticketId,
  currentUser,
  onSubmit,
  history,
  submitting,
  submitSuccess
}) => {
  const classes = useStyles();

  const handleCancel = () => {
    history.push(`/ticket/${ticketId}`);
  };

  // Calculate initial values from template
  const initialValues = getInitialValuesFromTemplate(template);

  return (
    <ApplicationPage currentUser={currentUser}>
      <div className={classes.container}>
        <Link to={`/ticket/${ticketId}`} className={classes.back}>
          <Back /> Back to Work Order
        </Link>

        {submitSuccess ? (
          <div className={classes.successMessage}>
            <h3>Order submitted successfully!</h3>
            <p>Returning to work order...</p>
          </div>
        ) : (
          <StoreOrderForm
            template={template}
            onSubmit={onSubmit}
            onCancel={handleCancel}
            submitting={submitting}
            initialValues={initialValues}
          />
        )}
      </div>
    </ApplicationPage>
  );
};

StoreOrderPage.propTypes = {
  template: PropTypes.object,
  ticketId: PropTypes.string.isRequired,
  currentUser: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitSuccess: PropTypes.bool.isRequired
};

export default StoreOrderPage;
